<template>
  <div class="app">
    <div class="app-container" v-if="!loading">
      <sidebar class="app-container-sidebar" v-if="!in404 && loggedIn && ($route.meta.requiresAuth || (!inRoomLobby && !showSpaceLobby))" />

      <div class="app-container-content" :class="{'app-container-content--no-sidebar': sidebarIsHidden}">
        <!-- place video conferencing here so that you can use it in the background while on area/space overview -->
        <Linkframe :partial="getIfOnJoinedRoomPage && isDesktop"/>
        <video-conference-wrapper
          v-show="showConferencing"
          v-if="renderConferencing"
        />
        <router-view
          v-show="showRouter"
          :key="$route.name"
        />
      </div>

      <app-status-update v-if="!in404" :data="currentPopup" />
      <SpaceinTour v-if="showTour && currentRouteName === 'area' && !currentPopup && !ifModal" />
    </div>

    <newModalRoot v-if="loggedIn && !loading" />
    <loading-screen v-else-if="loading" />
    <div class="tooltip-container">
      <FadeTransition :inDuration="100" :outDuration="100">
        <Tooltip v-if="getTooltip" :data="getTooltip" :key="getTooltip.id"/>
      </FadeTransition>
    </div>
  </div>
</template>

<script>
import LoadingScreen from '@/components/global/loading/LoadingScreen.vue';
import AppStatusUpdate from '@/components/modals/status_update/AppStatusUpdatePopup.vue';
import Sidebar from '@/components/sidebar/Sidebar.vue';
import VideoConferenceWrapper from '@/components/conferencing/VideoConferenceWrapper.vue';
import Linkframe from '@/components/conferencing/LinkFrame.vue';
import SpaceinTour from '@/components/global/SpaceinTour.vue';
import Tooltip from '@/components/global/Tooltip.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';

import newModalRoot from './framework/modals/components/newModalRoot.vue';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'App',
  components: {
    LoadingScreen,
    Sidebar,
    AppStatusUpdate,
    VideoConferenceWrapper,
    newModalRoot,
    Linkframe,
    SpaceinTour,
    Tooltip,
    FadeTransition
  },
  computed: {
    ...mapGetters([
      'getIfOnJoinedRoomPage',
      'getCurrentNotification',
      'showRoomLobby',
      'inRoomLobby'
    ]),
    ...mapGetters({
      currentRouteName: 'routing/routeName',
      currentPopup: 'popups/currentPopup',
      ifCurrentUsersRoomIsHub: 'getIfCurrentUsersRoomIsHub',
      loggedIn: 'api/auth/isLoggedIn',
      loading: 'loading/isLoading',
      currentLink: 'linkFrame/current',
      ifModal: 'modal/modal',
      sidebarIsHidden: 'sidebar/isHidden',
      showTour: 'tour/ifShow',
      getTooltip: 'tooltip/getTooltip',
      isDesktop: 'viewport/isDesktop',
      requiresAuth: 'routing/ifRequiresAuth',
      showSpaceLobby: 'guest/space/onLobby',
    }),
    in404: vm => vm.currentRouteName === '404',
    showRouter: vm => (!vm.currentLink && !vm.getIfOnJoinedRoomPage) || (!vm.requiresAuth && vm.currentRouteName !== 'area'),
    showConferencing: vm => (vm.getIfOnJoinedRoomPage && (!vm.currentLink || (vm.currentLink && vm.isDesktop))),
    renderConferencing: vm => (!vm.ifCurrentUsersRoomIsHub && vm.loggedIn && vm.currentRouteName !== 'home' && !vm.showRoomLobby && !vm.showSpaceLobby),
  },
  methods: {
    ...mapActions(['viewport/initListeners', 'debug/initDebug'])
  },
  created() {
    this['viewport/initListeners']()

    if (process.env.NODE_ENV === "development") {
      this['debug/initDebug']()
    }
  },
};
</script>

<style lang="scss">
@import '@/scss/pages/app.scss';

.tooltip-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}
</style>
